import {
  ContactAddToType,
  contactsApi,
} from '@texas/api/endpoints/contactsApi';
import { useApiRequest } from '@texas/api/hooks/useApiRequest';
import { ContactsTable } from '@texas/components/contacts/ContactsTable';

export function CustomerContacts({
  customerId,
  customerName,
}: {
  customerId: number;
  customerName: string;
}) {
  const { request: disconnectRequest } = useApiRequest(
    contactsApi.disconnectCustomer,
  );
  const { request: connectRequest } = useApiRequest(
    contactsApi.connectCustomer,
  );

  return (
    <ContactsTable
      addToType={ContactAddToType.Customer}
      referenceId={customerId}
      referenceName={customerName}
      disconnectRequest={disconnectRequest}
      connectRequest={connectRequest}
    />
  );
}
